import React, { useCallback, useMemo, useState } from 'react';
import { Modal, Image } from '@landing/ui';
import { BasicSlider } from 'components/BasicSlider';
import { CustomDot, CustomPagination } from './utils';

import * as styles from './GalleryModal.module.scss';

export default function GalleryModal({ items, initialSlide, isOpen, closeModalCallback }) {
  const [current, setCurrent] = useState(initialSlide);

  const setCurrentKey = useCallback((prev, next) => {
    setCurrent(next);
  }, []);

  const sliderSettings = useMemo(
    () => ({
      customPaging: CustomDot.bind(null, items.length, current),
      appendDots: CustomPagination,
      dotsClass: 'slick-pagination',
      dots: true,
      swipe: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      initialSlide,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            arrows: false,
          },
        },
        {
          breakpoint: 545,
          settings: {
            customPaging: CustomDot.bind(null, items.length, current),
            adaptiveHeight: true,
            arrows: false,
          },
        },
      ],
    }),
    [items.length, current, initialSlide],
  );

  return (
    <Modal isOpen={isOpen} closeModalCallback={closeModalCallback} theme="photoGallery">
      <div className={styles.slider}>
        <BasicSlider beforeChange={setCurrentKey} {...sliderSettings}>
          {items.map(({ image }, i) => (
            <Image
              key={image.desktop}
              className={styles.picture}
              classImage={styles.image}
              src={image}
              alt={`Slide-${i + 1}`}
            />
          ))}
        </BasicSlider>
      </div>
    </Modal>
  );
}
